import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'

import { parseEntityId, parseEntityName } from '../../../../models/entity'
import * as actions from '../../../Autocomplete/actions'
import { renderAutocomplete } from '../../fieldRenderers'
import { required, validAutocomplete } from '../../fieldValidators'

class EntityAutocomplete extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleOnBlur = this.handleOnBlur.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleChange ({ value, reason }) {
    if (reason === 'input-changed') { this.props.requestEntity(this.props.entity, value) }
  }

  handleOnBlur (e, { highlightedSuggestion }, input) {
    if ((!parseEntityName(e.target.value) || !parseEntityId(e.target.value)) && e.target.value !== '') {
      e.target.value =
        highlightedSuggestion && highlightedSuggestion[this.props.entity]
      input.onChange(e)
    }
  }

  handleSelect (e, { suggestion, suggestionValue }, input) {
    e.target.value = suggestionValue
    input.onChange(e)
    if (this.props.onSelected) {
      this.props.onSelected(suggestionValue)
    }
  }

  render () {
    const {
      entityValues = [],
      entity,
      label = 'Entidad',
      name = 'entity',
      placeholder,
      autoFocus,
      required: isRequired = true,
      value = ''
    } = this.props

    const values = entityValues || []
    const validators = [validAutocomplete]
    if (isRequired) validators.push(required)

    return (
      <Field
        name={name}
        label={label}
        component={renderAutocomplete}
        validate={validators}
        entity={entity}
        placeholder={placeholder}
        values={values}
        autoFocus={autoFocus}
        type='text'
        onChangeInput={this.handleChange}
        onBlurInput={this.handleOnBlur}
        onSuggestionSelected={this.handleSelect}
        value={value}
      />
    )
  }
};

const mapStateToProps = (state, ownProps) => ({
  entityValues: state.autocomplete.entityValues[ownProps.entity]
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(EntityAutocomplete)
